import { classifierColumns, classifierSchema } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const revokedBadgeReasonsClassifierEntityName = 'revokedBadgeReasonsClassifier';
export const revokedBadgeReasonsClassifierSchema = classifierSchema.extend({
    title: z.string(),
    description: z.string().optional(),
    canReissue: z.boolean().optional(),
});
export const revokedBadgeReasonsClassifierColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { title: {
        type: 'string-required',
        index: true,
    }, description: {
        type: 'string',
    }, canReissue: {
        type: 'boolean',
    } }));
